import React from 'react';

const MapControls = ({ onZoomIn, onZoomOut, onReset, onStyleToggle, currentStyle }) => {
  return (
    <div className="absolute bottom-12 right-8 flex flex-col gap-3 z-10">
      <div className="bg-surface-container-high/80 backdrop-blur-xl p-2 rounded-xl flex flex-col gap-2 shadow-2xl">
        <button
          onClick={onZoomIn}
          className="p-2 hover:bg-primary/20 rounded-lg text-primary transition-colors"
          aria-label="Zoom in"
        >
          <span className="material-symbols-outlined">add</span>
        </button>
        <div className="h-[1px] bg-white/5 mx-2"></div>
        <button
          onClick={onZoomOut}
          className="p-2 hover:bg-primary/20 rounded-lg text-primary transition-colors"
          aria-label="Zoom out"
        >
          <span className="material-symbols-outlined">remove</span>
        </button>
      </div>
      <button
        onClick={onReset}
        className="bg-surface-container-high/80 backdrop-blur-xl p-3 rounded-xl text-primary shadow-2xl hover:bg-primary/20 transition-colors"
        aria-label="Reset view"
      >
        <span className="material-symbols-outlined">my_location</span>
      </button>
      <button
        onClick={onStyleToggle}
        className="bg-surface-container-high/80 backdrop-blur-xl p-3 rounded-xl text-primary shadow-2xl hover:bg-primary/20 transition-colors"
        aria-label={currentStyle === 'satellite' ? 'Switch to dark map' : 'Switch to satellite'}
        title={currentStyle === 'satellite' ? 'Dark Map' : 'Satellite View'}
      >
        <span className="material-symbols-outlined">
          {currentStyle === 'satellite' ? 'dark_mode' : 'satellite_alt'}
        </span>
      </button>
    </div>
  );
};

export default MapControls;
